import { rpcHost } from '../../../MessagingClient/instance';
import { PublicApiMessaging } from './Interface/Messaging';

type GlobalCustomRpcHandler = (customArgs: unknown[]) => Promise<unknown>;

export const GlobalMessaging: PublicApiMessaging = {
    declareCustomRpc(customRpcName: string, handler: GlobalCustomRpcHandler): void {
        rpcHost().declareCustomRpc(customRpcName, handler);
    },
};
